var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOccupancyCrushed = function SvgOccupancyCrushed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 16-.231-7.287a1.77 1.77 0 0 0-3.538 0L1 16zM10 16l-.231-7.287a1.77 1.77 0 0 0-3.538 0L6 16zM15 16l-.231-7.287a1.77 1.77 0 0 0-3.538 0L11 16z"
  }))));
};
export default SvgOccupancyCrushed;